import { Box, Button, Grid, MenuItem, Stack, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CustomSelect from "../../../../../components/ui/Select";
import PropTypes from "prop-types";

interface MappingFileCommentsKeysProps {
  readCommentsFile: () => Promise<void>;
  onBack: () => void;
  headingsFromFile: string[];
  updateFieldsMapped: (
    name: "email" | "first_name" | "last_name" | "phone_number" | "comment",
    value: string
  ) => void;
}

type MappingFieldKey = "email" | "first_name" | "last_name" | "phone_number" | "comment";
type CustomSelectChangeEvent =
  | React.ChangeEvent<HTMLInputElement>
  | (Event & { target: { value: unknown; name: string } });

export const MappingFileCommentsKeys: React.FC<
  MappingFileCommentsKeysProps
> = ({
  headingsFromFile,
  updateFieldsMapped,
  onBack,
  readCommentsFile,
}) => {
  const handleSelectChange = (event: CustomSelectChangeEvent) => {
    const key = event.target.name as MappingFieldKey;
    updateFieldsMapped(key, String(event.target.value));
  };

  return (
    <Stack sx={{ width: "100%", padding: "1.3rem" }}>
      <Grid container spacing={2}>
        <Grid size={4} spacing={2}>
          <MappingAttribute name="First Name" />
          <MappingAttribute name="Last Name" />
          <MappingAttribute name="Email" />
          <MappingAttribute name="Phone Number" />
          <MappingAttribute name="Comment" />
        </Grid>
        <Grid size={4}>
          <MappingArrow />
          <MappingArrow />
          <MappingArrow />
          <MappingArrow />
          <MappingArrow />
        </Grid>
        <Grid size={4}>
          <CustomSelect
            label={"Map First Name"}
            sx={{ width: "130px", mb: ".8rem" }}
            onChange={handleSelectChange}
            name="first_name"
            size="small"
            defaultValue={headingsFromFile[0]}
          >
            {headingsFromFile.map((heading, index) => {
              return (
                <MenuItem key={index} value={heading}>
                  {heading}
                </MenuItem>
              );
            })}
          </CustomSelect>
          <CustomSelect
            label={"Map Last Name"}
            name="last_name"
            onChange={handleSelectChange}
            defaultValue={headingsFromFile[0]}
            sx={{ width: "130px", mb: ".8rem" }}
            size="small"
          >
            {headingsFromFile.map((heading, index) => {
              return (
                <MenuItem key={index} value={heading}>
                  {heading}
                </MenuItem>
              );
            })}
          </CustomSelect>
          <CustomSelect
            defaultValue={headingsFromFile[0]}
            onChange={handleSelectChange}
            name="email"
            label={"Map Email"}
            sx={{ width: "130px", mb: ".8rem" }}
            size="small"
          >
            {headingsFromFile.map((heading, index) => {
              return (
                <MenuItem key={index} value={heading}>
                  {heading}
                </MenuItem>
              );
            })}
          </CustomSelect>
          <CustomSelect
            label={"Map Phone Number"}
            onChange={handleSelectChange}
            name={"phone_number"}
            defaultValue={headingsFromFile[0]}
            sx={{ width: "130px", mb: ".8rem" }}
            size="small"
          >
            {headingsFromFile.map((heading, index) => {
              return (
                <MenuItem key={index} value={heading}>
                  {heading}
                </MenuItem>
              );
            })}
          </CustomSelect>
          <CustomSelect
            label={"Map Comment"}
            name={"comment"}
            onChange={handleSelectChange}
            defaultValue={headingsFromFile[0]}
            sx={{ width: "130px", mb: ".8rem" }}
            size="small"
          >
            {headingsFromFile.map((heading, index) => {
              return (
                <MenuItem key={index} value={heading}>
                  {heading}
                </MenuItem>
              );
            })}
          </CustomSelect>
        </Grid>
      </Grid>

      <Box
        sx={{
          mt: "1rem",
          padding: ".5em .6em",
          display: "flex",
          justifyContent: "flex-end",
          gap: 2,
        }}
      >
        <Button variant="outlined" onClick={onBack}>
          Back
        </Button>
        <Button variant="contained" onClick={readCommentsFile}>
          Proceed
        </Button>
      </Box>
    </Stack>
  );
};

MappingFileCommentsKeys.propTypes = {
  readCommentsFile: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  headingsFromFile: PropTypes.arrayOf(PropTypes.string).isRequired,
  updateFieldsMapped: PropTypes.func.isRequired,
};

const MappingAttribute: React.FC<{ name: string }> = ({ name }) => {
  return (
    <Box
      sx={{
        padding: ".6rem",
        borderRadius: "0.5rem",
        border: `1px solid #CBD5E1`,
        mb: ".5rem",
      }}
    >
      <Typography variant="body2">{name}</Typography>
    </Box>
  );
};

MappingAttribute.propTypes = {
  name: PropTypes.string.isRequired,
};

const MappingArrow: React.FC = () => {
  return (
    <Box
      sx={{
        padding: ".6rem",
        borderRadius: "0.5rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        mb: ".5rem",
      }}
    >
      <ArrowForwardIcon sx={{ width: "100%" }} />
    </Box>
  );
};
